import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const route = [
  { path: 'ShiHaoJiedu', component: () => import('@/views/ShiHaoJiedu/index.vue'), meta: { title: '谥号解读' } },
  { path: 'ChuKingPedigree', component: () => import('@/views/ChuKingPedigree/index.vue'), meta: { title: '楚王世系' } },
  { path: 'TuDiGuansi', component: () => import('@/views/TuDiGuansi/index.vue'), meta: { title: '土地官司' } },
  { path: 'ChuGuoYuanYuan', component: () => import('@/views/ChuGuoYuanYuan/index.vue'), meta: { title: '楚国渊源' } },
  { path: 'JiuZuoMuyuan', component: () => import('@/views/JiuZuoMuyuan/index.vue'), meta: { title: '九座墓园' } },
  { path: 'ChuKingTimeLine', component: () => import('@/views/ChuKingTimeLine/index.vue'), meta: { title: '楚王生平' } },
  { path: 'XuanZhiBuJu', component: () => import('@/views/XuanZhiBuJu/index.vue'), meta: { title: '选址布局' } },
  { path: 'ChuFanYiShi', component: () => import('@/views/ChuFanYiShi/index.vue'), meta: { title: '楚藩轶事' } },
  { path: 'ChuKingBrief', component: () => import('@/views/ChuKingBrief/index.vue'), meta: { title: '明楚简史' } },
  { path: 'GuDaiMingRen', component: () => import('@/views/GuDaiMingRen/index.vue'), meta: { title: '古代名人' } },
  { path: 'DaMeiJingGuan', component: () => import('@/views/DaMeiJingGuan/index.vue'), meta: { title: '历史景观' } },
  { path: 'ChuTuWenWu', component: () => import('@/views/ChuTuWenWu/index.vue'), meta: { title: '出土文物' } },
  { path: 'MingFanChengFu', component: () => import('@/views/MingFanChengFu.vue'), meta: { title: '明藩沉浮' } },
  { path: 'LongQuanSiJi', component: () => import('@/views/LongQuanSiJi.vue'), meta: { title: '龙泉四季' } },
]

const routes = [
  {
    path: '/',
    component: () => import('@/views/home.vue'),
    children: route
  },
  {
    path: '/ZhiShiku',
    component: () => import('@/views/ZhiShiku/index.vue'),
    meta: { title: '知识库' }
  },
  {
    path: '/ZhiShiJiansuo',
    component: () => import('@/views/ZhiShiJiansuo/index.vue'),
    meta: { title: '知识检索' }
  },
  {
    path: '/InstanceDetail',
    component: () => import('@/views/InstanceDetail/index.vue'),
    meta: { title: '实例详情' }
  },

  {
    path: '/Home',
    component: () => import('@/views/Home/index.vue'),
    meta: { title: '首页' }
  },
  {
    path: '/WenDa',
    component: () => import('@/views/WenDa/index.vue'),
    name: 'WenDa',
    meta: { title: '问答' }
  },
  {
    path: '/ViewImage',
    component: () => import('@/views/ViewImage/index.vue'),
    meta: { title: '查看图片' }
  }
]
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  mode: 'history', // hash  history
  routes
})

export default router
